import type { Component } from 'solid-js';

import { cardStyles } from '../components/common';

export const NotFoundPage: Component = () => (
	<div class={cardStyles('p-10 text-center')}>
		<h1 class="text-2xl font-bold m-0">not found</h1>
	</div>
);
